import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Form, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import * as Yup from 'yup';
import Error from "../../../components/Error";
import { useEffect, useState } from "react";
import { requestSupportContact } from "../../../services/profile.service";
import { toast } from "react-toastify";
import {Card, CardFooter} from "./styles";
import { UserType } from "../../../../context/userContext/props";

const validationSchema = Yup.object({
    username: Yup.string().trim().required("Este campo é obrigatório"),
    email: Yup.string().trim().required("Este campo é obrigatório").email('Email inválido'),
    subject: Yup.string().required("Este campo é obrigatório"),
    message: Yup.string().trim().required("Este campo é obrigatório"),
}).required();

export const SupportContactManager = (props: any): JSX.Element => {
    const { t: translation } = useTranslation();
    const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(validationSchema) });

    const [username, setUsername] = useState<string>()
    const [email, setEmail] = useState<string>()
    const [subject] = useState<any>();
    const [message, setMessage] = useState<string>('Olá, gostaria de realizar a integração entre a deduca e a dstore. ')
    const [loading, setLoading] = useState(false);    

    useEffect(() => {
        let usuario = localStorage.getItem("user-store");
        if (usuario) {
            let auth: UserType = JSON.parse(usuario)
            setUsername(auth.username)
            setEmail(auth.email)
        }

    }, [])

    const onSubmit = (params: any) => {
        setLoading(true)
        requestSupportContact(params).then((response: any) => {
            toast.success("Solicitação enviada com sucesso!");
            setLoading(false)
            setMessage('')
        }).catch((err) => {
            toast.error(err.response.data[0]);
            setLoading(false)
        })
    };

    return (
        <div>
            <Card>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {!loading && (
                        <>
                            <Form.Group className="mb-2">
                                <Form.Label className="text-darker-grey"> {translation('contactForm.labelName')}</Form.Label>
                                <Form.Control value={username} type="text" placeholder={translation('contactForm.labelName')}  {...register("username", { required: true })} />
                                {errors.username ? (<div className="w-100"> <Error>{errors.username?.message}</Error> </div>) : ""}
                            </Form.Group>

                            <Form.Group className="mb-2">
                                <Form.Label className="text-darker-grey">{translation('contactForm.labelEmail')}</Form.Label>
                                <Form.Control value={email} type="text" placeholder={translation('contactForm.labelEmail')}  {...register("email", { required: true })} />
                                {errors.email ? (<div className="w-100"> <Error>{errors.email?.message}</Error> </div>) : ""}
                            </Form.Group>

                            <Form.Group className="mb-2">
                                <Form.Label className="text-darker-grey">{translation('contactForm.labelSubject')}</Form.Label>
                                <Form.Select style={{ color: '#6473FF', cursor: 'pointer' }} value={subject} placeholder={translation('contactForm.labelSubject')}  {...register("subject", { required: true })} >
                                    <option value="Integracao" >{translation('manager.settings.integration')}</option>
                                    <option value="Duvidas" >{translation('contactForm.subject.doubts')}</option>
                                    <option value="Assinatura">{translation('contactForm.subject.subscription')}</option>
                                    <option value="Renovação">{translation('contactForm.subject.renew')}</option>
                                    <option value="Cancelar">{translation('contactForm.subject.cancel')}</option>
                                </Form.Select>
                                {errors.subject ? (<div className="w-100"> <Error>{errors.subject?.message}</Error> </div>) : ""}
                            </Form.Group>
                            <Form.Group className="mb-2">
                                <Form.Label className="text-darker-grey">{translation('contactForm.labelMessage')}</Form.Label>
                                <Form.Control value={message} as="textarea" rows={5} style={{ resize: 'none' }} placeholder={translation('contactForm.labelMessage')}  {...register("message", { required: true })} />
                                {errors.message ? (<div className="w-100"> <Error>{errors.message?.message}</Error> </div>) : ""}
                            </Form.Group>
                        </>
                    )}

                    <CardFooter>
                        {
                            loading ? (
                                <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }} />
                            ) : (
                                <><Button variant="primary" className="btn-rounded" type="submit">{translation('contactForm.send')}</Button></>
                            )
                        }
                        
                    </CardFooter>
                </Form>
            </Card>
        </div>
    )
}